import _sfc_main from "./Avatar.vue2.mjs";
/* empty css             */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "avatar-container" }, [_c("img", { staticClass: "avatar", attrs: { "src": _setup.src, "onerror": _setup.handleError } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "460d4fdf"
);
const Avatar = __component__.exports;
export {
  Avatar as default
};
